const STORAGE_KEY = 'theme:free-shipping-progress:animation-played';

class FreeShippingProgressComponent extends HTMLElement {
  connectedCallback() {
    if (this.#hasPlayedAnimation()) {
      this.setAttribute('data-animation-played', 'true');
      return;
    }

    this.removeAttribute('data-animation-played');
    this.#markAnimationPlayed();
  }

  #hasPlayedAnimation() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) === 'true';
    } catch (error) {
      return false;
    }
  }

  #markAnimationPlayed() {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, 'true');
    } catch (error) {
    }
  }
}

if (!customElements.get('free-shipping-progress-component')) {
  customElements.define('free-shipping-progress-component', FreeShippingProgressComponent);
}
